import type { OrderDetail, OrderListItem, OrderStatus, Paginated, UpdateOrderStatusInput } from '@najah/core'
import { api } from './api'

export interface OrderFilter {
  page?: number
  pageSize?: number
  status?: OrderStatus
  from?: string
  to?: string
  search?: string
}

export interface AdminOrderDetail extends OrderDetail {
  items: (OrderDetail['items'][number] & { available: number })[]
}

export const ordersApi = {
  list: (filter: OrderFilter) =>
    api<Paginated<OrderListItem>>('/orders', { query: filter as Record<string, string | number | undefined> }),
  counts: () => api<Record<OrderStatus, number>>('/orders/counts'),
  get: (id: string) => api<AdminOrderDetail>(`/orders/${id}`),
  updateStatus: (id: string, body: UpdateOrderStatusInput) =>
    api<AdminOrderDetail>(`/orders/${id}/status`, { method: 'POST', body }),
}
